<script>
  import resources from './resources'

  export default {
    name: 'config-advanced',

    mixins: [resources]
  }
</script>

<template lang="pug">
  page(title="Configurações Avançadas", icon="")
    .col-xs-12.content
      .container-fluid.zero-margin
        .row
          .col-xs-12.white-bg(style='margin-top:30px;')
            div.configuracoes-avancadas
              .col-xs-12.col-md-6
                h4 Notificações
                .line
                  .text Agendamento de Consultas
                  .switch(
                    @click.prevent="doToogleNotifySettings('schedule')",
                    :class="{true: settings.notify.schedule, false: !settings.notify.schedule}"
                    )
                    .dot
                .line
                  .text Cancelamento de Consultas
                  .switch(
                    @click.prevent="doToogleNotifySettings('cancel')",
                    :class="{true: settings.notify.cancel, false: !settings.notify.cancel}"
                    )
                    .dot
                .line
                  .text Transferência de Consultas
                  .switch(
                    @click.prevent="doToogleNotifySettings('transfer')",
                    :class="{true: settings.notify.transfer, false: !settings.notify.transfer}"
                    )
                    .dot
                .divider

                .subtitle Tipo de Notificações
                .line
                  .text E-mail
                  .switch(
                    @click.prevent="doToogleNotifySendSettings('email')",
                    :class="{true: settings.notify.send.email, false: !settings.notify.send.email}"
                    )
                    .dot
                .line
                  .text SMS
                  .switch(
                    @click.prevent="doToogleNotifySendSettings('sms')",
                    :class="{true: settings.notify.send.sms, false: !settings.notify.send.sms}"
                    )
                    .dot

                .line
                  .text
                    | App Mobile
                    small (Smartphones)
                  .switch(
                    @click.prevent="doToogleNotifyPushAppSettings()",
                    :class="{true: settings.notify.send.push.app, false: !settings.notify.send.push.app}"
                    )
                    .dot

                .line
                  .text
                    | App Web
                    small (Push Notifications)
                  .switch(
                    @click.prevent="doToogleNotifyPushWebSettings()",
                    :class="{true: settings.notify.send.push.web, false: !settings.notify.send.push.web}"
                    )
                    .dot
                .divider
              .col-xs-12.col-md-12
                .divider.hidden-md.hidden-lg
                h4 Alertar Dependentes
                .row.m-b-100
                  .col-md-10.col-xs-10
                     f-select-dependent(
                        name="dependents"
                        v-model="settings.notify.dependent",
                        :get-all="true",
                        @selected="doPushNotifyDependentsSettings",
                        :multiple="true",
                        :searchable="true")

                  .col-md-2
                    .line.select(style="margin-top: 15px;")
                      .switch(
                        @click.prevent="doToogleNotifyDependentsSettings()",
                        :class="{true: settings.notify.dependents, false: !settings.notify.dependents}"
                        )
                        .dot
</template>
<style scoped>
  .m-b-100 {
    margin-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/app/patient/config/index.vue